module.exports = __webpack_public_path__ + "static/media/ourStoryGreen.6380dbaf.svg";